import EditTemplate from "../components";

export default EditTemplate